import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { WarehouseVm } from './warehouse.vm';
import { Type } from 'class-transformer';

export class GetWarehousesVm extends PageResponseVm<WarehouseVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => WarehouseVm)
  objects: WarehouseVm[];
}
